// inviteFriend
export default {
  inviteFriend: '邀請好友',
  shareTitle: '邀請好友，立賺現金',
  shareDesc: '每邀1位好友賺350港元，多邀多得！ 達標額外享V3會員',
  activityTips: '限邀新用戶，需首入金HK$ 10,000或等值美元及以上',
  hkUsMarket: '港美股',
  lifeFreeCommission: '終身免佣',
  inviteNow: '立即邀請',
  myInviteLink: '我的邀請鏈接',
  myInvite: '我的邀請',
  accumulatedRewards: '累計獲得獎勵',
  inviteNum: '邀請人數',
  all: '全部',
  registered: '已注册',
  accountOpened: '已開戶',
  deposited: '入金達標',
  traded: '已交易',
  viewInviteDetails: '查看邀請詳情',
  inviteRecord: '邀請記錄',
  inviteDetail: '邀請詳情',

  cardOneTitle: '邀好友，送股票! 多邀多得！',
  cardOneLabel1: '邀請好友加入盈寶，每位獎勵',
  cardOneDesc1: '好友首次入金≥20,000 HKD，股票交易≥1筆',
  cardOneLabel2: '邀請好友交易達標，每位獎勵',
  cardOneDesc2: '好友30天內不出金且股票交易次數≥10筆',
  cardOneLabel3: '邀請好友數≥6人',
  cardOneDesc3: '好友需入金≥20,000 HKD，股票交易≥1筆',
  cardTitle: '邀請好友加入盈寶，即可領取：',
  cardDesc: '註：交易指成交港股或美股及日內融，不含申購貨幣基金、新股',

  cardTwoTitle: '如何邀請',
  cardTwoStep1: '分享好友',
  cardTwoStep2: '注册開戶',
  cardTwoStep3: '好友入金',

  userNickName: '用戶昵稱',
  inviteTime: '邀請時間',
  inviteStatus: '邀請狀態'
}
